import script from "./MailSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MailSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MailSidebar.vue?vue&type=style&index=0&id=d45d2dce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d45d2dce"]])

export default __exports__